/* app/js/src/components/external-mam/external-mam-providers-setup/external-mam-providers-setup-step-one/external-mam-providers-setup-step-one.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.lns-container div .checkboxes::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.lns-container div .checkboxes::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.lns-container div .checkboxes::-webkit-scrollbar-corner {
  background: transparent;
}
.lns-container div .checkboxes::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.lns-container div .checkboxes::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.lns-container div .checkboxes::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.lns-container div .checkboxes::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.lns-container div .checkboxes::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  display: flex;
  padding: 25px 100px;
  flex-direction: column;
  gap: 20px;
}
.step-title {
  display: flex;
  padding: 15px 0px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.step-title h2 {
  flex: 1 0 0;
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
}
.step-desc {
  flex: 1 0 0;
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.login-data-container {
  display: flex;
  padding: 25px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  background: rgba(35, 47, 58, 0.05);
}
.login-data-container .login-data-container-inner {
  display: flex;
  padding: 50px 145px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  gap: 20px;
  background: rgb(255, 255, 255);
}
.login-data-container .login-data-container-inner * {
  width: 100%;
}
.login-data-container .login-data-container-inner .login-data-container-title {
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
}
.login-data-container .login-data-container-inner .login-data-container-desc {
  height: 24px;
  align-self: stretch;
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.login-data-container .login-data-container-inner .login-data-container-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.login-data-container .login-data-container-inner .login-data-container-form .login-data-container-button {
  color: rgb(255, 255, 255);
  border-color: #2dbbfc;
  background-color: #2dbbfc;
  border-radius: 4px;
  border: 1px solid;
  display: flex;
  padding: 9px 16px 9px 9px;
  align-items: flex-end;
  gap: 8px;
}
.login-data-container .login-data-container-inner .login-data-container-form .login-data-container-button span {
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-transform: uppercase;
}
.lns-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.lns-container div {
  display: flex;
  padding: 15px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
  height: 300px;
  overflow: hidden;
}
.lns-container div h3 {
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  align-self: stretch;
}
.lns-container div .checkboxes {
  max-height: 300px;
  overflow: auto;
}
.mam-settings-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
}
.mam-settings-container div {
  display: flex;
  padding: 10px 0px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}
.auth-type-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.auth-type-field .auth-type-label {
  color: rgba(0, 0, 0, 0.85);
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.auth-type-field mat-radio-group {
  display: flex;
  gap: 24px;
}
::ng-deep .mat-form-field-wrapper {
  padding: 0;
}
/*# sourceMappingURL=external-mam-providers-setup-step-one.component.css.map */
